import { getCreditCardNumberPreview, getCreditCardType } from 'shared/utils'
import DeleteButton from '@components/DeleteButton'
import Icon from '@components/Icon'
import CircleLoader from '@components/CircleLoader'
import styles from './styles.module.scss'

const CreditCard = ({ default: isDefault, nickName, cardLast4, cardType, onDelete, setDefault, expDate, pending }) => (
    <li className={styles.creditCard} onClick={setDefault}>
        <Icon type={getCreditCardType(cardType)} className="mr-3" size="sm" withShadow />
        <span className={styles.title} mr-2>
            {getCreditCardNumberPreview({ nickName, cardLast4, expDate })}{' '}
            <>
                {isDefault && <Icon className={styles.defaultCard} type="checked_new" />}
                {onDelete && <DeleteButton onClick={onDelete} />}
            </>
        </span>
        {pending && <CircleLoader className="ml-2 mt-1" size="small" />}
    </li>
)

export default CreditCard
